/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class MessageContentMediaType {
    static General = 0;
    static Image = 1;
    static Voice = 2;
    static Video = 3;
    static File = 4;
    static Portrait = 5;
    static Favorite = 6;
    static Sticker = 7;
    static Moments = 8;
}
